import React from "react";

export const About: React.FC = () => {
  return (
    <div className="pt-5 container-fluid" id="about">
      <div className="row">
        <div className="col-md-5 mb-3">
          <h2>About</h2>

          <p>
            This is the unofficial ranking of{" "}
            <a
              href="https://wgi.org/percussion/p-current-entries/"
              title="Current Entries Percussion - WGI"
              target="_blank"
              rel="noopener noreferrer"
            >
              WGI-bound ensembles
            </a>{" "}
            through the season. Rankings are purely based on scores from
            regionals across the country, and do not reflect any official
            rankings by{" "}
            <a
              href="http://www.wgi.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              WGI
            </a>
            . Since scores and judges vary by regional, this is not meant to be
            an accurate representation of the rankings going into{" "}
            <a
              href="https://wgi.org/percussion/world-championships-per/"
              title="World Championships - WGI"
              target="_blank"
              rel="noopener noreferrer"
            >
              WGI finals
            </a>
            , just a loose idea of where each ensemble stands. The score shown
            is the unit&#39;s latest total score (with penalties).
          </p>
        </div>

        <div className="col-md-5 offset-md-1 mb-3">
          <h2>Donate/Feedback</h2>
          <div>
            If you like what you see, please
            <form
              className="d-inline px-1"
              action="https://www.paypal.com/cgi-bin/webscr"
              method="post"
              target="_blank"
            >
              <input type="hidden" name="cmd" value="_s-xclick" />
              <input
                type="hidden"
                name="encrypted"
                value="-----BEGIN PKCS7-----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-----END PKCS7-----"
              />
              <input
                type="image"
                src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_SM.gif"
                name="submit"
                alt="PayPal - The safer, easier way to pay online!"
                style={{ marginBottom: "-5px" }}
              />
              <img
                alt=""
                src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
                width="1"
                height="1"
              />
            </form>
            some money to help pay for the upkeep of this site. Anything missing
            or incorrect?{" "}
            <a
              href="https://docs.google.com/forms/d/1dJps0NcI2yrVc5WAoCc_Aqx9QS1j82yP8L7LGgc_9P0/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="feedback"
            >
              Send feedback
            </a>
            .
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
